import React from 'react';
import { EmptyState, EmptyStateProps, Box } from '@wix/design-system';

export const CardsGridEmptyState = (props: EmptyStateProps) => (
  <Box direction="vertical" padding="SP7">
    <EmptyState {...props} />
  </Box>
);
